export default "__VITE_PUBLIC_ASSET__e8048b7b__"